import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Activity, Bank2, BriefcaseFill, ExclamationCircleFill, EyeFill, } from 'react-bootstrap-icons';
import { useLocation, useNavigate } from "react-router-dom";
import * as BullCache from "../../util/BullCache";
import { isMobile } from '../../util/GeneralUtil';
import "../custom.css";

function Footer() {
  var [date, setDate] = useState(new Date());
    var user = BullCache.getFromCache("user");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    var timer = setInterval(() => setDate(new Date()), 1000)
    return function cleanup() {
      clearInterval(timer);
    };
  }, []);

  const handleAccount = () => {
    navigate("/ledger");  
  };

  const handleRejectionLog = () => {
    navigate("/mobilerejectionlog");  
  };

  const handlePosition = () => {
    navigate("/positionreport");
  }
  const handleTrade = () => {
    navigate("/trademobile");
  }
  const handleWatch = () => {
    navigate("/mobilewatch");
  }

  return (<>

    {!isMobile ? (
      <div className="fixed-bottom">

        <Row className="bg-white">
          <Col xl={9}>
            <marquee><span className="text-danger fw-bold ">{user?.instruction}</span></marquee>
          </Col>
          <Col xl={3}>
            <div className="text-center"><label className='fs-5 fw-bold text-primary'>{date.toLocaleTimeString()}</label>
              <label className='fs-6 fw-bold text-warning'>&nbsp;{date.toLocaleDateString()}</label>
            </div>
          </Col>
        </Row>
    </div>
    ) :(location.pathname !== "/login" && location.pathname !== "/Login" && location.pathname !== "/" ? 
        <div className="fixed-bottom no-print">
        <Row className="bg-footer">
          <Col className="d-flex flex-column align-items-center vert-line">
            <EyeFill
              className="p-1 d-sm-none d-md-block icon-color w-50"
              size={30}
              onClick={handleWatch}
            />
            <span className="custom-text">WatchList</span>
          </Col>

          <Col className="d-flex flex-column align-items-center vert-line">
            <Activity size={30} className="icon icon-color w-50"
             onClick={handleTrade}
            />
            <span className="custom-text">Trade</span>
          </Col>

          <Col className="d-flex flex-column align-items-center vert-line">
            <BriefcaseFill
              className="p-1 d-sm-none d-md-block icon-color w-50"
              size={30}
              onClick={handlePosition}
            />
            <span className="custom-text">Position</span>
          </Col>

          <Col className="d-flex flex-column align-items-center vert-line">
            <ExclamationCircleFill
              className="p-1 d-sm-none d-md-block icon-color w-100"
              size={30}
              onClick={handleRejectionLog}
            />
            <span className="custom-text">Log</span>

          </Col>

          <Col className="d-flex flex-column align-items-center">
            <Bank2
              className="p-1 d-sm-none d-md-block icon-color w-50 mt-2"
              size={30}
              onClick={handleAccount}
            />
            <span className="custom-text">Account</span>
          </Col>
        </Row>
      </div>
      : null
    )}
  </>
  );
}

export default Footer;